<template>
  <Flex
    center
    :class="{ 'cursor-pointer': !disabled, 'bg-gray-100': !disabled, 'bg-gray-200': disabled }"
    class="w-[42px] min-w-[42px] h-full text-[#5F6368] border-slate-300">
    <IconSolid :icon="props.icon" />
  </Flex>
</template>

<script setup>
const props = defineProps({
  icon: String,
  disabled: Boolean,
})
</script>
